import { LoadingAnimation } from '../Lottie/LoadingAnimation'

const MainLandingPageLoader = () => {
  return (
    <div className='fixed flex items-center justify-center'>
      <div className='text-center'>
        <LoadingAnimation />
      </div>
    </div>
  )
}

export default MainLandingPageLoader
